export default {
  tunnelFork: require('@/assets/images/pixso-automotive-official/scenarios/tunnel-fork.jpg'),
  parking: require('@/assets/images/pixso-automotive-official/scenarios/parking.jpg'),
  overpass: require('@/assets/images/pixso-automotive-official/scenarios/overpass.jpg'),
  urbanCanyon: require('@/assets/images/pixso-automotive-official/scenarios/urban-canyon.jpg'),
  complexTraffic: require('@/assets/images/pixso-automotive-official/scenarios/complex-traffic.jpg'),
  treeLinedStreet: require('@/assets/images/pixso-automotive-official/scenarios/tree-lined-street.jpg')
}
